<template>
  <div class="w-full filternone lg:mt-24 md:mt-24 mt-12">
    <ExclusivePopup
      :isActive="isDetailsActive"
      :selectedExclusive="selectedExclusive"
      @close="toggleDetails"
    />
    <div class="flex justify-center pb-24 lg:px-0 md:px-0 px-6 min-neg-mt">
      <div class="absolute">
        <div class="">
          <!-- <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
           
          />  -->
        </div>
      </div>

      <div
        class="relative lg:w-3/4 md:w-3/4 w-full items-center md:py-12 lg:py-12"
      >
        <div class="w-full"></div>
        <div class="w-full">
          <div class="">
            <p
              class="title text-center sm-fsize25 md:font-normal lg:font-normal font-bold lg:mt-12 md:mt-12"
            >
              Our Service Categories
            </p>
          </div>
        </div>
        <div class="mt-8">
          <b-card no-body class="border-none bg-transparent">
            <div class="related-products row">
              <!-- Item Image -->
              <div
                class="p-4 cursor-pointer smh-400 justify-center items-center col-lg-3 lg:my-8 md:my-8"
                v-for="item in get_AllService"
                :key="item.objectId"
              >
                <div class="w-full bg-f4f5f6">
                  <img
                    class="w-swiper m-auto image w-350 h-375 sm-object sm-h300 border15"
                    :src="hasError ? defaultImage : image(item.icon)"
                    :alt="item.title"
                    @click="toggleDetails(true, item)"
                  />
                </div>
                <div class="lg:mb-12 md:mb-12 mb-2">
                  <p
                    class="letterspacing-2px fsize16 mc-title font-bold text-primary uppercase text-center mt-4"
                    @click="toggleDetails(true, item)"
                  >
                    {{ item.title }}
                  </p>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//  import "swiper/swiper-bundle.min.css";
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
import ExclusivePopup from "./cg-exclusivePopup.vue";
export default {
  components: {
    swiper,
    swiperSlide,
    ExclusivePopup,
  },

  data() {
    return {
      selectedExclusive: {},
      isDetailsActive: false,
      swiperOption: {
        slidesPerView: 3,
        observer: true,
        observeParents: true,
        spaceBetween: 25,
        slidesPerColumn: 1,
        slidesPerColumnFill: "row",
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 55,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 55,
            slidesPerColumn: 1,
          },
        },

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      related_items: [
        {
          name: "Template 1",
          // image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 2",
          image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 3",
          image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 4",
          image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 5",
          image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 6",
          image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 7",
          image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 8",
          image: require("@/assets/images/logo.png"),
        },
      ],
      products: [],

      hasError: false,
      defaultImage:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
    };
  },
  methods: {
    async function() {
      let payload = "testing";
      this.$store.dispatch("services/get_all", payload);
    },
    image(x) {
      return `${this.$imageURL}/${x}`;
    },
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedExclusive = item;
    },
  },
  computed: {
    ...mapState("services", { get_AllPartner: "get_AllPartner" }),
    ...mapState("services", { get_AllService: "get_AllService" }),
  },
  mounted() {
    this.function();
    this.$store.dispatch("services/get_all");

    // console.log(this.get_/AllPartner);
  },
};
</script>

<style lang="scss">
#item-detail-page {
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .image-div {
    display: flex;
    flex-flow: row;
  }

  .image > img {
    margin: auto 6px;
    height: 60px;
    width: 60px;
  }
  .item-features {
    background-color: #f7f7f7;
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
    // padding-right: 2rem;
    // padding-left: 2rem;

    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.1),
          0 5px 12px 0 rgba(0, 0, 0, 0.08) !important;
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(0.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0;
    }

    .swiper-button-prev {
      left: 0;
    }
  }
}
.cust-h150px {
  height: 150px;
}
.neg-mt {
  margin-top: -10rem;
}
.min-neg-mt {
  @media (min-width: 575px) {
    margin-top: -10rem;
  }
}
.swiper-container-multirow > .swiper-wrapper {
  @media (max-width: 576px) {
    flex-wrap: inherit !important;
  }
}
</style>
